import {connect} from 'react-redux';

import {FrameTypesEnum} from '../../../../../libs/shared/core/src/models/api/apiTypes';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {makeGetInstalledApplicationFromId} from '../../../../store/data/applications/applicationsSelectors';
import {SidePanelFrame} from '../../../../store/stateless/sidePanelFrameSelectors';
import {SidePanelApplicationFrameCard} from './sidePanelApplicationFrameCard';

/*
 * Props.
 */

interface SidePanelApplicationFrameCardContainerProps {
  frame: SidePanelFrame;
}

/*
 * Selectors.
 */

function getApplicationId(_state: AppState, props: SidePanelApplicationFrameCardContainerProps) {
  const {frame} = props;
  if (frame.frameType !== FrameTypesEnum.APPLICATION_ENTRY_POINT) {
    return undefined;
  }
  return frame.applicationId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SidePanelApplicationFrameCardContainerProps>()(() => ({
  application: makeGetInstalledApplicationFromId(getApplicationId),
}));

export const SidePanelApplicationFrameCardContainer = connect(mapStateToProps)(SidePanelApplicationFrameCard);
